import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
  CanLoad,
  Route,
  UrlSegment,
} from '@angular/router';
import { Observable, map, tap } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate, CanLoad {
  constructor(private userService: UserService, protected router: Router) {}
  
  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const accesRole: any = ['administrator','manager','tutor']//route.data;
    return this.userService.getUserRole$.pipe(
      // map((role) => role === accesRole?.role),
      map((role) => accesRole.includes(role)),
      tap((isAdmin: boolean) => {
        if (!isAdmin) this.router.navigate(['/']);
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const accesRole: any = ['administrator','manager','tutor']//route.data;
    return this.userService.getUserRole$.pipe(
      // map((role) => role === accesRole?.role),
      map((role) => accesRole.includes(role)),
      tap((isAdmin: boolean) => {
        if (!isAdmin) this.router.navigate(['/']);
      })
    );
  }
  
}
